var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9219 22H3.07598C2.48173 22 2 21.5183 2 20.924V3.07813C2 2.11954 3.15898 1.63948 3.8368 2.3173L21.6827 20.1632C22.3605 20.841 21.8805 22 20.9219 22ZM5.22791 18.772H15.9879L5.22791 8.01223V18.772Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRuler);
export default __webpack_public_path__ + "static/media/triangle-ruler.d4876e0ba4630944bade404de7b53706.svg";
export { ForwardRef as ReactComponent };